import React from 'react';
import Loading from './components/Loading'
import title from './images/splash_title.png';
import urls from './configs/urls'
import './css/App.css';
import ls from 'local-storage'
import axios from 'axios';
import {Redirect} from "react-router";


class App extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            loading: true,
            redirect: false,
            noUser: false,
            cities :[],
            city_id : ls.get("city_id"),
            city_name : ls.get("city_name"),
        };

    }
    componentDidMount() {
        this.checkUpdate();
    }

    render() {
        if(!this.state.city_id)
            return (<Redirect push to='/city'/>);
        if(this.state.redirect)
            return (<Redirect push to='/home'/>);
        if(this.state.noUser)
            return (<Redirect push to='/phone'/>);

        return (
            <div className="App">
                <Loading loading={this.state.loading}/>
                <header className="App-body">
                    <img src={title} className="App-logo" alt="logo" />
                    <p>{ls.get("testKe")}</p>
                </header>
            </div>
        );
    }

    checkUpdate() {
        if(!ls.get("token")) {
            this.setState({noUser:true});
            return;
        }
        axios.get(urls.baseUrl+urls.checkUpdate+"?version=75&is_from_app=1")
            .then(res => {
                let code = res.data.code;
                if(code == 200){
                    const cities = res.data.cities;
                    ls.set("cities",cities);
                    this.setState({cities:cities,redirect:true});
                }
                else if(code == 203){
                    alert("Message");
                }
                else{
                    alert(" No OK : "+code);
                }
            })
    }

}
export default App;
